import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyARBamBuZ3fnphXDH4UsXR5J_cC7Cw9KQA",
  authDomain: "lnb-staging-483105.firebaseapp.com",
  projectId: "lnb-staging-483105",
  storageBucket: "lnb-staging-483105.firebasestorage.app",
  messagingSenderId: "315639738240",
  appId: "1:315639738240:web:67efde0d7d6228d92cdb65",
  measurementId: "G-DP2GRDKDRE"
};

// Initialize Firebase for web
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, app };
